export const EvaluationTrainingHotGravity = {
    path: '/evaluation_training_hot_gravities',
    name: 'evaluation_training_hot_gravities',
    component: () => import('@/views/Evaluation/Gravity/EvaluationTrainingHotGravityPage.vue'),
    props: {
      type: 'EVALUATION_TRAINING_HOT',
    },
    children: [
        {
            path: '/evaluation_training_hot_gravities/add',
            name: 'evaluation_training_hot_gravities.add',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_gravities/edit/:id',
            name: 'evaluation_training_hot_gravities.edit',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_gravities/delete/:id',
            name: 'evaluation_training_hot_gravities.delete',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_gravities/view/:id',
            name: 'evaluation_training_hot_gravities.view',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
    ]
}